/**
 * App Bundle Entry Point
 *
 * This file serves as the entry point for the main application bundle.
 * It imports all common JavaScript modules in the correct order.
 *
 * Bundle includes:
 * - HTMX core library
 * - HTMX SSE extension
 * - UI utilities (Toast, Loading, MobileMenu, etc.)
 * - Modal system
 * - Real-time notifications
 */

// i18n bootstrap — must be first so window.t() is available to all modules
import '../static/js/i18n.js';

// Core HTMX and extensions (must be loaded first)
import './htmx-bootstrap.js';

// HTMX SSE extension — registers the "sse" extension on the global htmx bridged
// by htmx-bootstrap. MUST be imported after htmx-bootstrap and is required for
// every hx-ext="sse" feature (room events, notifications). Omitting it silently
// disables all SSE in production (dev loads static/js/sse.js as a separate tag).
import '../static/js/sse.js';

// Shared utilities
import '../static/js/ui-utils.js';

// Modal handling
import '../static/js/modal.js';

// Real-time notifications via SSE
import '../static/js/notifications-realtime.js';

// SSE resilience — re-syncs missed state after a dropped/suspended SSE
// connection (e.g. mobile screen-off). Event-driven only; no interval polling.
// Depends on the htmx:sseOpen bridge above, so import it last.
import '../static/js/sse-resilience.js';

console.log('✅ App bundle loaded');
